<template>
    <template-login>
        <template #title>
            <h1>{{ $tr('Вход в Облачное хранилище') }}</h1>
        </template>
        <template #preamble>
            <!-- <p>Où le monde savant et le monde ignorant sont aussi embarrassés l'un ou l'autre.</p>     -->
        </template>
    </template-login>
</template>

<script>
import TemplateLogin from '@topomatic/tap/src/components/TemplateLogin.vue';

export default {
    name: 'AlbatrosLogin',
    components: {
        TemplateLogin,
    },
};
</script>
